module.exports = __webpack_public_path__ + "assets/img/4176-tz.svg";